import { createContext, useContext, useEffect, useLayoutEffect, useRef, useState } from "react";

// Width available to pages (the writing column); falls back to the window width
export const PageWidth = createContext(null);

export const PAGE_SIZES = [["paperback", "Paperback book (6 × 9 in)", 600, 1.5], ["letter", "Letter (8.5 × 11 in)", 720, 11 / 8.5], ["a4", "A4", 700, 297 / 210]];
const GAP = 14;

export const usePageDims = (size) => {
  const [vw, setVw] = useState(window.innerWidth);
  useEffect(() => { const f = () => setVw(window.innerWidth); window.addEventListener("resize", f); return () => window.removeEventListener("resize", f); }, []);
  const avail = useContext(PageWidth);
  const [, , , r] = PAGE_SIZES.find((p) => p[0] === size) || PAGE_SIZES[0];
  const room = avail || vw;
  const w = Math.round(room - (room < 640 ? 24 : 64));
  return { w, h: Math.round(w * r), pad: w < 480 ? 28 : Math.min(120, Math.round(w * 0.08)) };
};

// Lays content on paper pages (a visual preview); reports how many pages it took
export const PagedFrame = ({ size, startPage = 1, onPages, children, testId = "paged-frame" }) => {
  const { w, h, pad } = usePageDims(size);
  const inner = useRef(null);
  const [pages, setPages] = useState(1);
  useLayoutEffect(() => {
    const el = inner.current;
    const measure = () => { const n = Math.max(1, Math.ceil((el.scrollHeight + GAP) / h)); setPages(n); onPages?.(n); };
    measure();
    const ro = new ResizeObserver(measure);
    ro.observe(el);
    return () => ro.disconnect();
  }, [h]); // eslint-disable-line react-hooks/exhaustive-deps
  return (
    <div className="paged relative mx-auto my-8 shadow-[0_20px_60px_-20px_rgba(0,0,0,0.9)]" data-testid={testId}
      style={{ width: w, minHeight: pages * h, background: `repeating-linear-gradient(to bottom, #f3ecdd 0, #f3ecdd ${h - GAP}px, #cbbd9c ${h - GAP}px, #cbbd9c ${h}px)` }}>
      {Array.from({ length: pages }, (_, i) => (
        <span key={i} className="absolute right-5 font-code text-[11px] text-[#8a7a60] select-none pointer-events-none" style={{ top: i * h + 16 }} data-testid="page-number">{startPage + i}</span>
      ))}
      <div ref={inner} style={{ padding: `${pad}px ${pad}px` }}>{children}</div>
    </div>
  );
};
